<template>
  <!-- 首页 -->
  <div class="index_page">
    <!-- 导航菜单 -->
    <div class="nav_menu">
      <div class="logo" :class="{ logo_hidden: nav_collapse }">
        <transition name="move" mode="out-in">
          <h2 v-if="!nav_collapse" @click="nav_collapse = true">搜索指数</h2>
          <!-- <img class="nav_logo" src="@/assets/img/loginLogo.png" alt="" v-if="!nav_collapse" @click="nav_collapse = true"> -->
        </transition>
        <img
          class="nav_logo_mini"
          v-if="nav_collapse"
          src="@/assets/img/logo.svg"
          alt=""
          @click="nav_collapse = false"
        />
      </div>
      <div class="menu_box hide_scrollbar">
        <el-menu
          :default-active="onRoutes"
          class="el-menu-vertical-demo"
          :collapse="nav_collapse"
          :unique-opened="true"
          router
          background-color="#ffffff"
          text-color="#333333"
          :default-openeds="openeds"
          active-text-color="#409EFF"
        >
          <template v-for="item in routers">
            <!-- 有二级菜单 -->
            <template v-if="item.children">
              <el-submenu :index="item.path" :key="item.path">
                <!-- 一级 -->
                <template slot="title">
                  <i
                    :class="item.icon"
                    :style="
                      item.meta.activeName.includes($route.name)
                        ? 'color: #409EFF'
                        : ''
                    "
                  ></i>
                  <span
                    slot="title"
                    :style="
                      item.meta.activeName.includes($route.name)
                        ? 'color: #409EFF;'
                        : ''
                    "
                    >{{ item.meta.title }}</span
                  >
                </template>
                <!-- 二级 -->
                <template v-for="childItem in item.children">
                  <el-menu-item :index="childItem.path" :key="childItem.path">
                    <span
                      slot="title"
                      :style="
                        childItem.name == $route.name
                          ? 'color: #409EFF;font-weight:600'
                          : ''
                      "
                      >{{ childItem.meta.title }}</span
                    >
                  </el-menu-item>
                </template>
              </el-submenu>
            </template>
            <!-- 没有二级菜单 -->
            <template v-else>
              <el-menu-item :index="item.path" :key="item.path">
                <i
                  :style="
                    item.meta.activeName.includes($route.name)
                      ? 'color: #409EFF'
                      : ''
                  "
                  :class="item.icon"
                ></i>
                <span
                  slot="title"
                  :style="
                    item.meta.activeName.includes($route.name)
                      ? 'color: #409EFF;font-weight:600'
                      : ''
                  "
                  >{{ item.meta.title }}</span
                >
              </el-menu-item>
            </template>
          </template>
        </el-menu>
      </div>
      <!-- 退出登录按钮 -->
      <div class="out_btn" @click="loginOut">
        <el-tooltip effect="dark" content="退出登录" placement="bottom">
          <i class="icon el-icon-switch-button" />
        </el-tooltip>
      </div>
    </div>
    <!-- 页面内容 -->
    <div class="content_main">
      <div class="page_top">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item
            v-for="route in pageNameList"
            :key="route.path"
            :to="{ path: route.path }"
            >{{ route.title }}</el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>
      <div class="page_content">
        <div>
          <transition name="move" mode="out-in">
            <!-- <keep-alive> -->
            <router-view />
            <!-- </keep-alive> -->
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nav_collapse: true,
      routers: [],
      openeds: [],
      jobId: "",
    };
  },
  computed: {
    onRoutes() {
      return this.$route.path.replace("/index", "");
    },
    pageNameList() {
      return this.$store.state.pageNameList;
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(newValue, oldValue) {
        this.$store.state.pageNameList = [
          {
            title: newValue.meta.title,
            path: newValue.path,
          },
        ];
      },
    },
  },
  created() {
    this.getRouters();
  },
  mounted() {},
  methods: {
    // 获取路由列表
    getRouters() {
      this.$store.state.pageNameList = [
        {
          title: this.$route.meta.title,
          path: this.$route.path,
        },
      ];
      const route = this.$router.options.routes.find(
        (val) => val.path === "/index"
      );
      if (route) {
        let menu = JSON.parse(JSON.stringify(route.children));
        menu.forEach((_) => {
          if (_.path === "/siteManage") {
            delete _.children;
          }
        });
        this.routers = menu.filter((_) => _.name !== "jobProgressDetail");
      }
    },
    // 退出登陆
    loginOut() {
      this.$confirm("确认退出登陆吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: "false",
        cancelButtonClass: "loginout_close",
        confirmButtonClass: "loginout_confirm",
      }).then(() => {
        let token = localStorage.getItem("token");
        // this.$http({
        //   url: "loginOut",
        //   data: { token },
        // }).then((res) => {});
        // localStorage.removeItem('token');
        localStorage.clear();
        this.$router.replace("/login");
        this.$hint("您已退出登陆");
      });
    },
    // 搜索jobID
    searchJobId() {
      this.$refs.drawerDetail.init({ jobId: this.jobId });
      this.jobId = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.index_page {
  width: 100vw;
  height: 100vh;
  display: flex;
  background: #eee;
  overflow: hidden;
  .nav_menu {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
    .logo {
      width: 230px;
      height: 60px;
      font-size: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      transition: all 0.5s;
      white-space: nowrap;
      cursor: pointer;
      &:hover {
        .icon {
          opacity: 1;
        }
      }
      .icon {
        font-size: 22px;
        margin-right: 20px;
        transform: translateY(1px);
        cursor: pointer;
        opacity: 0.7;
        transition: all 0.5s;
      }
      .nav_logo {
        width: 110px;
        height: auto;
      }
      .nav_logo_mini {
        width: 30px;
        cursor: pointer;
      }
    }
    .logo_hidden {
      width: 64px;
    }
    .menu_box {
      height: 0;
      flex: 1;
      padding-bottom: 20px;
      box-sizing: border-box;
      overflow-y: scroll;
    }
    .el-menu {
      border: none;
      .el-menu-item:hover {
        background: #e9f2ff !important;
      }
    }
    .el-menu-vertical-demo:not(.el-menu--collapse) {
      width: 230px;
      min-height: 400px;
    }
    .out_btn {
      width: 100%;
      height: 60px;
      font-size: 18px;
      white-space: nowrap;
      color: #666;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      border-top: 1px solid #eee;
      box-sizing: border-box;
      .icon {
        cursor: pointer;
      }
      &:hover {
        font-weight: bold;
        color: #409eff;
        background: #e9f2ff;
      }
    }
  }
  .content_main {
    width: 0;
    flex: 1;
    height: 100%;
    min-width: 800px;
    display: flex;
    flex-direction: column;
    > div {
      position: relative;
      z-index: 10;
    }
    .page_top {
      width: 100%;
      height: 50px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 15px;
      box-sizing: border-box;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.1);
      .left {
        font-size: 14px;
        font-weight: bold;
      }
      .right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
    .page_content {
      width: 100%;
      height: 0;
      flex: 1;
      padding: 15px;
      box-sizing: border-box;
      overflow: hidden;
      > div {
        width: 100%;
        height: 100%;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.1);
        box-sizing: border-box;
        padding: 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue